import Modal from "react-modal";

export const OtbPurchasePlanModal = ({ actions, ctx, uiState }) => {
  const { onConfirm = () => {}, onClose = () => {} } = actions || {};
  const { collectionLabel, periodLabel, categoryLabel, units } = ctx || {};
  const { isOpen = false } = uiState || {};

  const title = [collectionLabel, periodLabel].filter(Boolean).join(" · ");

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      contentLabel="Analisar Plano de Compra"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.84)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          width: "520px",
          maxWidth: "calc(100vw - 40px)",
          boxSizing: "border-box",
          padding: "24px 22px 20px",
          border: "none",
          borderRadius: "10px",
          background: "#f8f9fb",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.38)",
          overflow: "visible",
        },
      }}
    >
      <div style={{ position: "relative", textAlign: "center" }}>
        <button
          onClick={onClose}
          aria-label="Fechar"
          style={{
            position: "absolute",
            top: -10,
            right: -6,
            width: 24,
            height: 24,
            padding: 0,
            border: "none",
            background: "transparent",
            color: "#777",
            cursor: "pointer",
            fontSize: 20,
            fontWeight: 400,
            lineHeight: "24px",
          }}
        >
          ×
        </button>

        <h3
          style={{
            margin: "0 0 6px",
            padding: 0,
            fontSize: "18px",
            lineHeight: "24px",
            fontWeight: 600,
            color: "#252b33",
          }}
        >
          Deseja analisar o Plano de Compra desta seleção?
        </h3>

        <p
          style={{
            margin: "0 0 18px",
            fontSize: "13px",
            lineHeight: "18px",
            color: "#747b86",
          }}
        >
          Você será direcionado para o Módulo do Plano de Compra
        </p>

        <div style={{ borderTop: "1px solid #e3e6eb", padding: "18px 0" }}>
          <div style={{ fontSize: "14px", fontWeight: 700, color: "#252b33" }}>
            {title}
          </div>

          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              color: "#747b86",
              textTransform: "uppercase",
            }}
          >
            {categoryLabel}
          </div>

          <div
            style={{
              marginTop: "14px",
              fontSize: "20px",
              fontWeight: 700,
              color: "#252b33",
            }}
          >
            {units} peças
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            borderTop: "1px solid #e3e6eb",
            paddingTop: "18px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              border: "1px solid #e3e6eb",
              borderRadius: "8px",
              background: "#fff",
              color: "#252b33",
              fontSize: "14px",
              cursor: "pointer",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
            }}
          >
            Cancelar
          </button>

          <button
            onClick={onConfirm}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              background: "#e8773a",
              color: "#fff",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.18)",
            }}
          >
            Analisar Plano de Compra
          </button>
        </div>
      </div>
    </Modal>
  );
};